import logo from './assets/logo.png'

const MAIN_SITE_URL = 'https://www.newsalist.net'
const VIDEOS_SITE_URL = 'https://videos.newsalist.net'

const MAIN_CATEGORIES = [
  { label: 'مقالات', href: `${MAIN_SITE_URL}/category/mqalat/` },
  { label: 'الإفتتاحيّة', href: `${MAIN_SITE_URL}/category/alifttahyh/` },
  { label: 'إعرف أكثر', href: `${MAIN_SITE_URL}/category/iarf-akthr/` },
  { label: 'الحدث', href: `${MAIN_SITE_URL}/category/alhdth/` },
  { label: 'أنتم والحدث', href: `${MAIN_SITE_URL}/category/antm-walhdth/` },
]

const Header = () => {
  return (
    <header className="site-header">
      {/* Bandeau supérieur — slogan + lien vidéos */}
      <div className="site-header__top">
        <div className="container site-header__top-inner">
          <span className="site-header__tagline">«&nbsp;لا تقف متفرجاً&nbsp;»</span>
          <a
            href={VIDEOS_SITE_URL}
            className="site-header__live-link"
            rel="noopener"
          >
            فيديو
          </a>
        </div>
      </div>

      {/* Bandeau principal — logo officiel Newsalist centré + badge فلاش */}
      <div className="site-header__brand-bar">
        <div className="container site-header__brand-inner">
          <a
            href={MAIN_SITE_URL}
            className="site-header__back"
            rel="noopener"
            aria-label="العودة إلى نيوزاليست"
            title="العودة إلى نيوزاليست"
          >
            <span className="site-header__back-long">العودة إلى نيوزاليست ←</span>
            <span className="site-header__back-short" aria-hidden="true">←</span>
          </a>

          <a href="/" className="site-header__brand" aria-label="نيوزاليست — فلاش نيوز">
            <img
              src={logo}
              alt="Newsalist"
              width={300}
              height={111}
              className="site-header__logo"
            />
            <span className="site-header__section">فلاش</span>
          </a>

          <span className="site-header__spacer" aria-hidden="true" />
        </div>
      </div>

      {/* Bandeau navigation catégories */}
      <nav className="site-header__nav" aria-label="التصفّح الرئيسي">
        <div className="container site-header__nav-inner">
          <a href="/" className="site-header__nav-link site-header__nav-link--active">
            فلاش نيوز
          </a>
          {MAIN_CATEGORIES.map((cat) => (
            <a
              key={cat.href}
              href={cat.href}
              className="site-header__nav-link"
              rel="noopener"
            >
              {cat.label}
            </a>
          ))}
        </div>
      </nav>
    </header>
  )
}

export default Header
